import React from 'react';
import { func, node, string } from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';

import css from './GetByDateBanner.module.css';

const IconClear = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    aria-hidden="true"
  >
    <line x1="1" y1="1" x2="9" y2="9" />
    <line x1="9" y1="1" x2="1" y2="9" />
  </svg>
);

/**
 * Banner for the "Get by date" (delivery date) filter.
 * - When a date is selected: "Showing bakers who can deliver by {date}" + Clear.
 * - When no date is selected: promo encouraging the customer to use the filter,
 *   with the filter opener button on the right.
 */
const GetByDateBanner = props => {
  const { className, formattedDate, onClear, filterButton } = props;
  const isSelected = !!formattedDate;

  return isSelected ? (
    <div className={classNames(css.activeBanner, className)}>
      <span className={css.emoji} role="img" aria-hidden="true">
        🎂
      </span>
      <span className={css.activeText}>
        <FormattedMessage
          id="SearchPage.getByDateBannerActive"
          values={{ date: <strong className={css.date}>{formattedDate}</strong> }}
        />
      </span>
      <button type="button" className={css.clearButton} onClick={onClear}>
        <IconClear />
        <FormattedMessage id="SearchPage.getByDateBannerClear" />
      </button>
    </div>
  ) : (
    <div className={classNames(css.promoBanner, className)}>
      <span className={css.emoji} role="img" aria-hidden="true">
        🎂
      </span>
      <div className={css.promoTexts}>
        <span className={css.promoTitle}>
          <FormattedMessage id="SearchPage.getByDatePromoTitle" />
        </span>
        <span className={css.promoSubtitle}>
          <FormattedMessage id="SearchPage.getByDatePromoSubtitle" />
        </span>
      </div>
      {filterButton ? <div className={css.promoButton}>{filterButton}</div> : null}
    </div>
  );
};

GetByDateBanner.defaultProps = {
  className: null,
  formattedDate: null,
  filterButton: null,
};

GetByDateBanner.propTypes = {
  className: string,
  formattedDate: string,
  onClear: func.isRequired,
  filterButton: node,
};

export default GetByDateBanner;
